import * as React from "react";
import PropTypes from "prop-types";
import { createIntl, createIntlCache, RawIntlProvider } from "react-intl";
import { getLang, getMessages } from "./i18n/i18nDataBuilder";

function flattenMessages(nestedMessages, prefix = "") {
	return Object.keys(nestedMessages).reduce((messages, key) => {
		const value = nestedMessages[key];
		const prefixedKey = prefix ? `${prefix}.${key}` : key;

		if (typeof value === "string") {
			messages[prefixedKey] = value;
		} else {
			Object.assign(messages, flattenMessages(value, prefixedKey));
		}

		return messages;
	}, {});
}

const flatMsgs = flattenMessages(getMessages());
const locale = getLang();
const intlProps = {
	locale,
	messages: flatMsgs,
};
const cache = createIntlCache();
export const intlRoot = createIntl(intlProps, cache);
export function withIntlRoot<P>(Component: React.ComponentType<P>): React.ComponentType<P> {
	return class WithIntlRoot extends React.Component<P> {
		static displayName = `withIntlRoot(${Component.displayName ?? Component.name})`;
		static contextTypes = {
			intl: PropTypes.object,
		};
		static childContextTypes = {
			intl: PropTypes.object,
		};

		getChildContext() {
			return { intl: intlRoot };
		}

		render() {
			return (
				<RawIntlProvider value={intlRoot}>
					<Component {...this.props} />
				</RawIntlProvider>
			);
		}
	};
}
